import { BankRegistrationGuide } from './BankRegistrationGuide';
import {
  IBK_COMPLETE_REGISTRATION_STEPS,
  IBK_NOTIFY_OPTIONS,
  IBK_REQUEST_CODE_STEPS,
} from './ibkGuide';
import { GATEWAY_NUMBER_DISPLAY } from './wooriGuide';

interface Props {
  authCode: string | null;
  codeRemainingSec: number | null;
  registered: boolean;
  onCancel: () => void;
  onComplete: () => void;
}

export function IBKRegistrationGuide(props: Props) {
  return (
    <BankRegistrationGuide
      {...props}
      bankAppLabel="기업은행 앱"
      authCodeLength={6}
      requestCodeSteps={IBK_REQUEST_CODE_STEPS}
      completeRegistrationSteps={IBK_COMPLETE_REGISTRATION_STEPS}
      notifyOptions={IBK_NOTIFY_OPTIONS}
      awaitingCodeMessage="5단계에서 [인증번호 발송]을 누르면 이곳에 자동으로 표시돼요."
      gatewayNumber={GATEWAY_NUMBER_DISPLAY}
    />
  );
}
